/* eslint-disable import/no-cycle */
import Store from "../redux/store";
import { setRequestStatus } from "../redux/slices/generalSlice";
import { ERROR_CODES } from "./constant";
import config from "../config";
const [AUTH_TOKEN] = config;
export const DispatchNotification = (message) => {
  Store.dispatch(
    setRequestStatus({
      description: message,
      header: "Error",
      error: true,
      show: true,
    })
  );
};

export const successMessage = (message) => ({
  error: false,
  show: true,
  header: "Success",
  description: message,
});

export const getCookie = () => {
  return true;
};

export const uniqueId = (i) =>
  (Math.random() + 1).toString(36).substring(7) + i;

export const numToString = (num) => {
  return num?.toLocaleString();
};
export function deBounce(func, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export const apiErrorResponse = (res = {}) => {
  if (
    ERROR_CODES.REGULAR_ERRORS.includes(res?.status) &&
    res?.data?.data?.errorMessage
  ) {
    return res?.data?.data?.errorMessage ?? "User not registered";
  }

  if (
    ERROR_CODES.VALIDATION_ERRORS.includes(res?.status) &&
    res?.data?.data?.length
  ) {
    return res?.data?.data[0]?.messageError ?? "Invalid Mobile Number";
  }

  return null;
};
export const formatDate = (dateString) => {
  if (!dateString) {
    return "";
  }
  try {
    // Parse the input date string
    const [day, month, year, time] = dateString.split(/[- ]/);
    const [hour, minute, second] = time.split(":");

    // Create a JavaScript Date object
    const date = new Date(year, month - 1, day, hour, minute, second);

    // Format date in en-GB (DD/MM/YYYY)
    const dateOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formattedDate = new Intl.DateTimeFormat("en-GB", dateOptions).format(
      date
    );

    // Format time in en-US (hh:mm AM/PM)
    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedTime = new Intl.DateTimeFormat("en-US", timeOptions)
      .format(date)
      .toUpperCase();

    // Combine both
    return `${formattedDate}, ${formattedTime}`;
  } catch (err) {
    return "";
  }
};
export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  const encryptValue = cvalue;
  document.cookie = `${cname}=${encryptValue};${expires};path=/`;
};

export const validateOrderNo = (order = "") => {
  return !order.match(/^[89]\d{9}$/);
};

export const validateNumber = (val) => {
  return val.match(/^\d+$/);
};

export const getAuthToken = () => {
  if (window?.location?.origin.includes("sit")) return AUTH_TOKEN["sit"];
  else if (window?.location?.origin.includes("prep")) return AUTH_TOKEN["prep"];
  else return AUTH_TOKEN["prod"];
};

// eslint-disable-next-line
export default {
  DispatchNotification,
  successMessage,
  getCookie,
  uniqueId,
  formatDate,
  validateOrderNo,
  validateNumber,
  getAuthToken,
};
